export const CONSTANTS  = {
    'AUTHOR': 'Azril Hakim',
    'AUTHOR_GITHUB_LINK': 'https://github.com/Azrael654/lofi-web',
}